import React from 'react';
import { DRAFT, LIVE } from '../ARSConstants';

type TChipStatusProps = {
    status: boolean
}

const ChipStatus = ({status} : TChipStatusProps) => {
    return (
        <div style={{backgroundColor: status ? '#CFFFCE' : '#E9E9EF'}} className={`tw-px-2 tw-py-1  tw-rounded-[3px] tw-justify-start tw-items-center tw-gap-1 tw-inline-flex`}>
            <label style={{color: status ? '#11980C' : '#5C5F62'}} className={`tw-text-xs`}>{status ? LIVE : DRAFT}</label>
        </div>
    );
}

export default ChipStatus;